module.exports = __webpack_public_path__ + "static/img/arrow_down.95d01857.png";